/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './StartATourModal.scss';

import React from 'react';
import Store from 'state/Store';
import classnames from 'classnames';

import BaseModal from 'components/shared/Modal/BaseModal';
import { startTour } from 'state/Tour/TourActions';
import { ReactComponent as TakeATour } from 'assets/icons/take-a-tour.svg';
import Content, { contentConverter } from 'services/Content';

const startATourContent = contentConverter.makeHtml(Content.startATourContent);
const startATourDisclaimer = contentConverter.makeHtml(
  Content.startATourDisclaimer
);

const CMM_SESSION_STORAGE_ID = 'seenCMM';
const hasSeenCMM = JSON.parse(sessionStorage.getItem(CMM_SESSION_STORAGE_ID));

class StartATourModal extends React.Component {
  startTour = () => {
    const { closeModal } = this.props;
    closeModal();
    Store.dispatch(startTour());
  };

  render() {
    const { showModal, closeModal, isIrtMessagesNotPriority } = this.props;

    const className = classnames('start-tour-modal-container', {
      'non-priority-modal-disabled': isIrtMessagesNotPriority && !hasSeenCMM
    });

    return (
      showModal && (
        <BaseModal
          hideClose={false}
          isOpen={showModal}
          title={' '}
          containerClassName={className}
          close={closeModal}
          disableClickOff={true}
          hideAnchor>
          <div className="start-tour-content-container">
            <TakeATour />
            <div className="start-tour-header">Designed with you in mind.</div>
            <div className="start-tour-content">
              <span dangerouslySetInnerHTML={{ __html: startATourContent }} />
            </div>
            <div className="start-tour-disclaimer">
              <span
                dangerouslySetInnerHTML={{ __html: startATourDisclaimer }}
              />
            </div>
            <div>
              <button
                className="start-tour-button-primary"
                onClick={this.startTour}>
                Start the Tour
              </button>
            </div>
            <div>
              <button
                className="start-tour-button-secondary"
                onClick={closeModal}>
                No, thank you
              </button>
            </div>
          </div>
        </BaseModal>
      )
    );
  }
}

export default StartATourModal;
